import path from "path";

import { ensureDir } from "fs-extra";

import { writeFileAsync } from "../Commons/FsUtils";
import { BuildCache, FormBuildCacheOptions } from "../FormWebpackConfiguration/CacheAssetsPlugin";

import { EngineSource } from "./Engine/EngineSource";
import { EngineVersionUtils } from "./EngineVersionUtils";

export interface FormMetaContent {
    themes?: string[];
    engineName: string;
    resourcesHash: string;
    useServerSideNormalization: boolean;
}

export async function writeFormMeta(
    resourcesPath: string,
    formName: string,
    engineSources: EngineSource,
    resourcesHash: string,
    themes: undefined | string[],
    useServerSideNormalization: boolean,
    buildCache?: BuildCache,
    buildCacheOptions?: FormBuildCacheOptions
): Promise<void> {
    await ensureDir(path.join(resourcesPath, "metas"));
    const formMetaContent: FormMetaContent = {
        engineName:
            engineSources.type === "LocalEngineSources"
                ? "local"
                : EngineVersionUtils.engineVersionToName(engineSources.version),
        resourcesHash: resourcesHash,
        useServerSideNormalization: useServerSideNormalization,
    };
    if (themes != undefined) {
        formMetaContent.themes = themes;
    }
    const content = JSON.stringify(formMetaContent, undefined, "  ");
    await writeFileAsync(path.join(resourcesPath, "metas", `${formName}.metas.json`), content, "utf8");
    if (buildCache != undefined && buildCacheOptions != undefined) {
        await buildCache.setContent(
            buildCacheOptions.generatorVersion,
            buildCacheOptions.gfv,
            buildCacheOptions.depsHash,
            path.join("metas", `${formName}.metas.json`),
            content
        );
    }
}
